exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-c8a70580] {\n  width: 1.25em;\n  height: 1.25em;\n  vertical-align: -0.2em;\n  fill: currentColor;\n  overflow: hidden;\n}\n", "", {"version":3,"sources":["C:/Users/steve/Desktop/Android/Xrross-SOC-Frontend/src/components/SvgIcon/index.vue"],"names":[],"mappings":";AAoCA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;CAClB","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.svg-icon {\n  width: 1.25em;\n  height: 1.25em;\n  vertical-align: -0.2em;\n  fill: currentColor;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c8a70580","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SvgIcon/index.vue
// module id = vhLF
// module chunks = 409